import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import EditBack from '../../components/common/EditBack';
import PlantDetail from '../../components/inventory/Dashboard/PlantReelsList';

import { useSessionContext } from '../../contexts/SessionContext';

export default function InventoryPlantReelDetail( props ){
    //console.debug("RTS Break InventoryPlantReelDetail");

   const {userAuthToken, apiRoot} = useSessionContext();
     
    const location = useLocation();
    const idGuid = location.state.idGuid;
    const display = location.state.display;
    //const mode = location.state.mode;
 
     const theme = useTheme();
     const smallForm = useMediaQuery(theme.breakpoints.down("sm"));
 
     const [isLoading, setIsLoading] = useState(true);
     const [hasError, setHasError] = useState(false);

     const [data, setData] = useState([]);
     

    const fetchData = useCallback((pIdGuid) => {
        setIsLoading(true);
        const today = new Date();
        let curDate = today.toISOString().split('T')[0];

        let apiURL = apiRoot + "/Inventory/GetPlantReelsDetail/" + pIdGuid + "?pDate=" + curDate;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    }, [apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        props.setIsModalFx(true);
        fetchData(idGuid);
    }, [props, fetchData, idGuid]);  


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '80vh';
        }
        return retValue;
    }; 


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Container component="main" maxWidth="md" sx={{mb:5}}>
            <CssBaseline />
            <Box sx={{my:2, width:'100%', display:'flex', justifyContent:'start', alignContent:'center'}}>
                <EditBack formDirty={0} />
                <Typography variant="h5" >Location Reel Details</Typography>
            </Box>
            <Box>
                <Box sx={{textAlign:'left', mt:1}}>
                    <Typography variant="h6" sx={{display:'inline'}}>Location:</Typography>
                    <Typography inline variant="h6" sx={{display:'inline', ml:1}}>{display}</Typography>
                </Box>
                <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                    <PlantDetail data={data} />
                </Box>
            </Box>
            <Box sx={{my:2, width:'100%', display:'flex', justifyContent:'start', alignContent:'center'}}>
                <EditBack formDirty={0} />
            </Box>            
        </Container>            
    );    
}
